import axios from "axios";

const API_URL =
  window.location.hostname === "localhost"
    ? process.env.REACT_APP_BACKEND_URL_LOCAL + "/api/partenaires"
    : process.env.REACT_APP_BACKEND_URL_PROD + "/api/partenaires";

// ✅ Récupérer les partenaires actifs
export const getPartenaires = async () => {
  try {
    const res = await axios.get(API_URL);
    return res.data.partenaires.filter(p => !p.archived) || [];
  } catch (err) {
    console.error("Erreur API :", err);
    return [];
  }
};

// ✅ Récupérer les partenaires archivés
export const getArchives = async () => {
  try {
    const res = await axios.get(API_URL);
    return res.data.partenaires.filter(p => p.archived) || [];
  } catch (err) {
    console.error("Erreur API Archives :", err);
    return [];
  }
};

// ✅ Ajouter un nouveau partenaire
export const ajouterPartenaire = async (data) => {
  try {
    await axios.post(API_URL, data, { headers: { "Content-Type": "application/json" } });
  } catch (err) {
    console.error("Erreur ajout partenaire :", err);
  }
};

// ✅ Archiver / Désarchiver un partenaire
export const toggleArchivePartenaire = async (id, archived) => {
  try {
    await axios.put(`${API_URL}/${id}`, { archived: !archived });
  } catch (err) {
    console.error("Erreur archivage/désarchivage :", err);
  }
};